import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from './assets/heart.svg'


const _hoisted_1 = { class: "app" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "site-logo"
  }),
  /*#__PURE__*/_createElementVNode("h1", null, "Hyrule Jobs")
], -1)
const _hoisted_3 = { class: "order" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_JobList = _resolveComponent("JobList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleClick('title')))
        }, "Order by title"),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleClick('salary')))
        }, "Order by salary"),
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleClick('location')))
        }, "Order by location")
      ])
    ]),
    _createVNode(_component_JobList, {
      jobs: _ctx.jobs,
      order: _ctx.order
    }, null, 8, ["jobs", "order"])
  ]))
}